<template>
  <div class="login__form">
    <h1>Iniciar sesión</h1>
    <form @submit.prevent="formController">
      <div class="input-box">
        <label>Email</label>
        <input type="email" name="email" id="email" v-model="model.email" />
      </div>

      <div class="input-box">
        <label>Contraseña</label>
        <input
          type="password"
          name="password"
          id="password"
          v-model="model.password"
        />
      </div>

      <div class="input-box input-box--recovery">
        <a :href="url_password_request">¿Olvidaste tu contraseña?</a>
      </div>

      <div class="input-box input-buttons">
        <button type="submit" class="btn btn--blue w-100">
          Iniciar sesión
        </button>
      </div>

      <div class="login-message">
        ¿No tienes cuenta?
        <a :href="url_register">Regístrate</a>
      </div>
    </form>
  </div>
</template>

<script>
import { customAlert } from '@general/js/utils/swalMessages'
import axios from 'axios'
import { reactive } from 'vue'

export default {
  props: {
    url_signin: {
      type: String,
      default: '',
    },
    url_password_request: {
      type: String,
      default: '',
    },
    url_register: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const model = reactive({
      email: '',
      password: '',
    })

    const formController = async () => {
      try {
        const { data } = await axios.request({
          url: props.url_signin,
          method: 'POST',
          data: model,
        })

        customAlert(data)
      } catch (error) {
        console.error(error)
      }
    }

    return {
      model,
      formController,
    }
  },
}
</script>
